export default function AddressComponent(props: {
  property: {
    advertisementAddress: string;
    zipAndCity: string;
    shortAddress: string;
    supplementaryCityName: string;
  };
}) {
  const { property } = props;

  let addressLine = "";
  let zipAndCity: string | null = null;
  if (property.advertisementAddress) {
    addressLine = property.advertisementAddress;
    if (property.advertisementAddress.endsWith(property.zipAndCity)) {
      addressLine = property.advertisementAddress
        .replace(property.zipAndCity, "")
        .trim();
      zipAndCity = property.zipAndCity;
    }
  } else {
    addressLine = `${property.shortAddress} ${property.supplementaryCityName}`;
    zipAndCity = property.zipAndCity;
  }

  return (
    <div className="h-[56px]">
      <div
        className={`${zipAndCity ? "line-clamp-1" : "line-clamp-2"} homepage-text-lg`}
      >
        {addressLine}
      </div>
      {zipAndCity && (
        <div className="line-clamp-1 text-header-level-3">{zipAndCity}</div>
      )}
    </div>
  );
}
